import { ControleEdition } from './controle-edition.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class ControleEditionList {
    static jsonMap = {
        controles: { key: 'controles', converter: new (ArrayClassConverterFactory.build(ControleEdition))(), optional: true, default: () => [] },
        controlesConformes: {
            key: 'controles_conformes',
            converter: new (ArrayClassConverterFactory.build(ControleEdition))(),
            optional: true,
            default: () => []
        }
    };

    controles: ControleEdition[];
    controlesConformes: ControleEdition[];
}
